import React from 'react';

import styled from 'styled-components';

import { CommunityIncentiveType } from '../../../types/incentives';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
`;

const AttachmentContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

const Attachment = styled.a`
  color: var(--dark-blue);
  margin-left: 5px;
  height: 16px;
  font-size: 12px;
  cursor: pointer;
  display: contents;
`;

type Props = {
  item: CommunityIncentiveType;
};

const CommunityIncentivesTableIncentivesAttachments = ({ item }: Props) => {
  const attachments = [...(item.files || []), ...(item.images || [])];
  return (
    <Container>
      {attachments.map((attachment) => (
        <AttachmentContainer key={attachment.id}>
          <img alt="attachment" src="/icons/attachment.svg" />
          <Attachment href={attachment.path} target="_blank" rel="noopener noreferrer">
            {attachment.file_name}.{attachment.file_extension}
          </Attachment>
        </AttachmentContainer>
      ))}
    </Container>
  );
};

export default CommunityIncentivesTableIncentivesAttachments;
